// Разбор ответа для clean/uploader

const canRedirect = function (result) {
    return result.redirect_to && ["success", "new"].includes(result.status);
};

const getErrors = function (response) {
    const errors = [];
    for (const field in response.form.errors) {
        let error = response.form.errors[field];
        if (field !== "__all__" && field !== "document") {
            error = field + ": " + error;
        }
        errors.push(error);
    }
    if (response.message) {
        errors.push(response.message);
    }
    return errors;
};

export default {
    canRedirect: canRedirect,
    getErrors: getErrors,
};
